{
    "AdminControl_PolicyApplied": "Politica applicata",
    "AdminControl_RecordingPolicyDetails": "Dettagli sulla politica di registrazione",
    "AdminControl_DisplayName": "Nome da visualizzare:",
    "AdminControl_UserPrincipalName": "Nome principale utente",
    "AdminControl_TeamsComplianceRecordingPolicy": "Politica di registrazione della conformità dei team",
    "AdminControl_PresenceStatus": "Stato di presenza",
    "AdminControl_CopiedToClipboard": "Copiato negli appunti",
    "AdminControl_ResponseSuccess": "Attività completata con successo",
    "NAME": "AdminControlLanguage"
}